import { useCallback, useRef } from 'react'

import { BottomSheetModal } from '@gorhom/bottom-sheet'

export const useOutOfOrderSheet = () => {
  const outOfOrderSheetModalRef = useRef<BottomSheetModal>(null)

  const openBottomModal = useCallback(() => {
    outOfOrderSheetModalRef.current?.present()
  }, [])

  const closeBottomModal = useCallback(() => {
    outOfOrderSheetModalRef.current?.close()
  }, [outOfOrderSheetModalRef])

  const handleOpenOutOfOrderSheet = () => openBottomModal()

  return {
    outOfOrderSheetModalRef,
    closeBottomModal,
    handleOpenOutOfOrderSheet
  }
}
